export const DOLLARS_FOR_1_CREDIT = 0.25;
export const GEOCODING_RECORDS_FOR_1_CREDITS = 25;
export const SA_CREDITS_FOR_1_POINT = 0.5;
export const ROUTING_CREDITS_FOR_1_ROUTE = 0.5;
